// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery-wrapper .thumb-wrapper .image{cursor:pointer;border-radius:.3rem;width:100%}", ""]);
// Exports
module.exports = exports;
